module.exports = __webpack_public_path__ + "static/img_2244-89c88ed3f5431e01fdf76a689da0450e.webp";